var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.129 18.088c-1.962.689-3.578-.102-3.254-1.985s2.185-5.917 2.45-6.68-.243-.971-.788-.66c-.314.18-.782.544-1.183.898-.111-.224-.268-.48-.386-.725.655-.657 1.75-1.536 3.046-1.855 1.548-.382 4.136.229 3.024 3.188-.795 2.11-1.356 3.565-1.71 4.649s.066 1.311.686.889c.483-.33.999-.78 1.377-1.128.174.284.23.374.403.7-.656.673-2.371 2.246-3.665 2.709M13.192 5.04c-.89.757-2.208.74-2.946-.037-.737-.777-.614-2.021.275-2.779.89-.757 2.208-.74 2.946.037.737.778.614 2.022-.275 2.78z"
  })));
};
export default SvgInfoIcon;